import PremiumPageHeader from './PremiumPageHeader';
import ListViewSettings from './ListViewSettings';
import { ListPageFloatingControls } from './ListPageLayout';

export const LIST_FORM_SUBTITLE = 'Browse and manage records from this list view.';
export const LIST_FORM_SUBTITLE_WITH_SETTINGS =
    'Configure filters using the settings icon. The table loads based on your saved date range preferences.';

function ListFormPageHeader({
    module,
    title,
    subtitle,
    viewKey,
    onSettingsSaved,
    headerActions,
    modeLabel = 'VIEW MODE',
    formLink,
    addNewLabel = 'Add New',
    onFormLinkClick,
    homeLink = '/Home',
    headerBackground,
    onExportCSV,
    onExportPDF,
}) {
    const resolvedSubtitle = subtitle || (
        viewKey && onSettingsSaved ? LIST_FORM_SUBTITLE_WITH_SETTINGS : LIST_FORM_SUBTITLE
    );

    const resolvedActions = headerActions || (
        viewKey && onSettingsSaved ? (
            <ListViewSettings viewKey={viewKey} onSaved={onSettingsSaved} />
        ) : null
    );

    return (
        <>
            <ListPageFloatingControls
                formLink={formLink}
                addNewLabel={addNewLabel}
                onFormLinkClick={onFormLinkClick}
                homeLink={homeLink}
                onExportCSV={onExportCSV}
                onExportPDF={onExportPDF}
            />
            <div className="container">
                <PremiumPageHeader
                    module={module}
                    title={title}
                    subtitle={resolvedSubtitle}
                    modeLabel={modeLabel}
                    headerActions={resolvedActions}
                    headerBackground={headerBackground}
                />
            </div>
        </>
    );
}

export default ListFormPageHeader;
